"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.tags.placeholder': 'Introducir etiquetas separadas por comas',
    'knowledge.tags.help': 'Presiona Enter para agregar cada etiqueta',
};
